import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// === CRITICAL: Preload hero image BEFORE React renders ===
// This makes the browser discover the LCP image from HTML, not from JS
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/2oMb5AVTctNw69Kf1Y1zf5/acostsdo.png';
preloadImg.fetchPriority = 'high';
document.head.appendChild(preloadImg);
// Preconnect to image CDN
const cdnConn = document.createElement('link');
cdnConn.rel = 'preconnect';
cdnConn.href = 'https://cdn.magicpatterns.com';
cdnConn.crossOrigin = 'anonymous';
document.head.appendChild(cdnConn);
render(<App data-id="element-592" />, document.getElementById('root'));